import { useEffect } from 'react';

import { Blog } from '@components';
import { scrollTop } from '@share/utils';

import './style.scss';

export function BlogPage() {
  useEffect(() => {
    setTimeout(() => {
      scrollTop();
    }, 300);
  }, []);

  return (
    <div className="blog-page">
      <Blog />
    </div>
  );
}
